import { createContext, useContext } from "react";
import { AlertProps } from "@mui/material";

interface AlertContextType {
  showAlert: (message: string, severity?: AlertProps["severity"]) => void;
}

export const AlertContext = createContext<AlertContextType | undefined>(
  undefined,
);

export const useAlert = (): AlertContextType => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlert must be used within an AlertProvider");
  }
  return context;
};
